import { Video } from './video';

export const VideoPlayer = Video;
